import { getAppType } from "../getAppType";
import { AppType } from "../constants/AppType";
import { useSettings } from "../settings/useSettings";

export function useStartPage() {
  const settings = useSettings();

  if (getAppType() === AppType.iframe) {
    return settings.iframe_startPage;
  }

  return "/frontpage";
}
